import React, { useContext } from "react";
import commonContext from "../../../common/context/common";
interface IProps {
    label: string;
    name: string;
    value: string;
}
export default function RadiobuttonForm(props: IProps) {
    const { setLead } = useContext(commonContext);
    return (
        <>
            <input
                type="radio"
                name={props.name}
                onChange={(e) => {
                    let state = {};
                    state[props.name] = e.target.value;
                    setLead(state);
                }}
                value={props.value}
            />
            <label className="openSans-SemiBold text-sm md:text-base lg:text-base xl:text-base">
                {props.label}
            </label>
        </>
    );
}
